/* eslint-disable react/destructuring-assignment */
import { useState } from "react";
import Chevron from "@Icons/Chevron";

import styles from "../USPSection.module.scss";
import Image from "@Components/Image";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import PropertyDetailsModal from "../../PropertyDetailsModal";
import Portal from "@Components/Portal";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
//

const CustomAccordionItem = (props: any) => {
  const [isDescriptionOpen, setisDescriptionOpen] = useState(false);
  const [open, setOpen] = useState(false);

  const { t } = useTranslationHook();
  const handleTitleClick = (dropdownTitle: string) => {
    setisDescriptionOpen(!isDescriptionOpen);
    gtagEventEmitter({
      action: "static_cta_dropdown_clicked",
      dropdown_title: dropdownTitle,
    });
  };

  const AccordianItemWithTitle = () => (
    <div className={styles.accordianTitleSection}>
      <div className={styles.accordianTitle}>{props.accordianTitle}</div>
      <AccordianItem />
      {props?.isDivider && <div className={styles.divider} />}
    </div>
  );

  const AccordianItem = () => (
    <div
      className={`${props.className} ${
        isDescriptionOpen ? "accordion-item active" : "accordion-item"
      }`}
      key={props.index}
    >
      <div
        className={formatClassNames(styles.accordionHeader, props.isDesktop && styles.desktop)}
        onClick={() => handleTitleClick(props?.title)}
        onKeyDown={() => handleTitleClick(props?.title)}
        role="none"
        data-testid="USPs"
      >
        <div data-testid="property-USP" className={styles.accordianItemTitleSection}>
          <div className={styles.accordianItemTitle}>
            {props?.leftIcon && (
              <div
                className={formatClassNames(
                  styles.iconWrapper,
                  props?.starClassname ? styles[props.starClassname] : "",
                )}
              >
                {props.leftIcon}
              </div>
            )}
            {props?.title}
          </div>
          {props.rightIcon && (
            <Image
              src={props.rightIcon}
              className={styles.rightIcon}
              alt={props.title}
              height="20"
              width="auto"
            />
          )}
        </div>
        <div className={isDescriptionOpen ? "chevron active" : "chevron"}>
          <Chevron height="12" width="12" />
        </div>
      </div>
      <div className={formatClassNames("accordion-content", styles.accordionContent)}>
        {props.content}
        <br />
        {props.description && (
          <div className={styles.learnMore} role="none" onClick={() => setOpen(true)}>
            {t("propertypage.propertyusp.learnmore")}
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      {props.accordianTitle ? <AccordianItemWithTitle /> : <AccordianItem />}
      {open && (
        <Portal rootId="forPortal">
          <PropertyDetailsModal
            header={props.title}
            actionButtonText={t("propertypage.propertyusp.close")}
            actionButtonVariant="primary"
            hidePropertyModal={() => setOpen(false)}
            isDesktop={props.isDesktop}
            actionButtonStyle={{
              height: "50px",
              fontWeight: 600,
              fontSize: 16,
            }}
          >
            {props.description}
          </PropertyDetailsModal>
        </Portal>
      )}
    </>
  );
};

export default wrapperHOC(CustomAccordionItem, {
  componentName: "CustomAccordionItem-PropertyUSPs-PropertyPage",
  showForChina: true,
});
